/**
 * Central DATX API Configuration
 * Ensures automatic seamless routing between local development and production hosting environments.
 */
export const isLocalhost = typeof window !== 'undefined' && (
  window.location.hostname === 'localhost' || 
  window.location.hostname === '127.0.0.1'
);

export const API_BASE_URL = (
  process.env.REACT_APP_API_URL || 
  (isLocalhost ? 'http://localhost:5000/api' : '/api')
).replace(/\/$/, '');

export default API_BASE_URL;
